import React, { useState, useEffect } from 'react';
import './ScreenoutScreen.css';

export default function ScreenoutScreen({ panelId, onRedirect }) {
  const [countdown, setCountdown] = useState(3);

  // Countdown und Auto-Redirect nur wenn Panel-ID vorhanden
  useEffect(() => {
    if (!panelId || !onRedirect) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [panelId, onRedirect]);
  return (
    <div className="screenout-screen-overlay">
      <div className="screenout-screen-container">
        {/* Info Icon */}
        <div className="screenout-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="url(#screenoutGradient)" fillOpacity="0.2"/>
            <circle cx="32" cy="32" r="30" stroke="url(#screenoutGradient)" strokeWidth="3"/>
            <path d="M32 20V36M32 44V44.5" stroke="url(#screenoutGradient)" strokeWidth="4" strokeLinecap="round"/>
            <defs>
              <linearGradient id="screenoutGradient" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#6845A5"/>
                <stop offset="100%" stopColor="#7c4dff"/>
              </linearGradient>
            </defs>
          </svg>
        </div>

        <h1 className="screenout-title">Danke für Ihre Zeit</h1>

        <p className="screenout-message">
          Diese Umfrage richtet sich an eine spezifische Zielgruppe und passt aktuell nicht zu Ihrem Profil.
        </p>

        <p className="screenout-submessage">
          Wir schätzen Ihr Interesse sehr und freuen uns über Ihren Besuch bei fairment.
        </p>

        {/* Countdown-Nachricht (nur bei Panel-Teilnehmern) */}
        {panelId && (
          <div className="redirect-countdown">
            <p className="redirect-message">
              Sie werden in <strong>{countdown}</strong> Sekunde{countdown !== 1 ? 'n' : ''} automatisch weitergeleitet...
            </p>
            {/* Manueller Fallback-Link falls Auto-Redirect fehlschlägt */}
            <p className="redirect-fallback" style={{ marginTop: '10px', fontSize: '14px', opacity: 0.8 }}>
              Falls die Weiterleitung nicht funktioniert,{' '}
              <a 
                href={`https://survey.maximiles.com/screenout?p=155033_0749f18f&m=${panelId}`}
                style={{ color: '#7c4dff', textDecoration: 'underline' }}
              >
                klicken Sie bitte hier
              </a>
            </p>
          </div>
        )}

        {/* CTA Button (nur wenn KEIN Panel-Redirect) */}
        {!panelId && (
          <a
            href="https://fairment.de"
            target="_blank"
            rel="noopener noreferrer"
            className="screenout-button"
          >
            Zu fairment.de
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 3L13 10L7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        )}
      </div>
    </div>
  );
}

